import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { STATISTIC_PROFIT_AGGREGATED } from 'api/query-keys';
import type { TGetProfitAggregatedStatisticRes } from 'api/swagger';
import type { IStatisticProfitFilter } from 'shared/stores/use-statistic-profit-filters';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface IParams {
  filters: IStatisticProfitFilter;
}

export const useGetProfitAggregatedStatistic = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<IStatisticProfitFilter>(qs, filters);

  return useQuery({
    queryKey: [STATISTIC_PROFIT_AGGREGATED, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetProfitAggregatedStatisticRes>(
        `/v1/statistics/profit-aggregated?${qs.toString()}`,
      );
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    enabled: !!filters.date && !!filters.userId,
  });
};
